import * as React from "react";

function IconTick(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        d="M8.216 15.208h.01v0h.002a1.04 1.04 0 00.76-.343s0 0 0 0L16.6 6.535a1.04 1.04 0 00-1.22-1.66l.097.184-.098-.184a1.043 1.043 0 00-.32.263l-6.853 7.496-3.279-3.494a1.043 1.043 0 10-1.52 1.427h0l4.049 4.307s0 0 0 0a1.04 1.04 0 00.76.333z"
        fill="#0071E9"
        stroke="#0071E9"
        strokeWidth={0.417}
      />
    </svg>
  );
}

const MemoIconTick = React.memo(IconTick);
export default MemoIconTick;
